export const detailedRows = []
